import { createSlice } from '@reduxjs/toolkit'
import { LoadingState } from '../types'
import {
  GetNotifications,
  GetNotificationsSuccess,
  GetNotificationsFailure,
  MarkAsReviewed,
  MarkAsReviewedSuccess,
  MarkAsReviewedFailure,
  SetUnreadCount,
  SetLoading,
  SetBundleDrawerOpen,
} from './contracts'
import { NotificationsState } from './types'

const initialState: NotificationsState = {
  notifications: [],
  loadingState: LoadingState.NEVER,
  error: null,
  isBundleDrawerOpen: false,
}

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    getNotifications(state, action: GetNotifications) {
      state.loadingState = LoadingState.LOADING
      state.error = null
    },
    getNotificationsSuccess(state, action: GetNotificationsSuccess) {
      state.loadingState = LoadingState.LOADED
      state.notifications = action.payload
      state.error = null
    },
    getNotificationsFailure(state, action: GetNotificationsFailure) {
      state.loadingState = LoadingState.ERROR
      state.error = action.payload
    },

    updateNotifications(state, action: GetNotifications) {
      state.error = null
    },
    updateNotificationsSuccess(state, action: GetNotificationsSuccess) {
      state.notifications = action.payload
      state.error = null
    },
    updateNotificationsFailure(state, action: GetNotificationsFailure) {
      state.loadingState = LoadingState.ERROR
      state.error = action.payload
    },
    markAsReviewed(state, action: MarkAsReviewed) {
      state.loadingState = LoadingState.LOADING
      state.error = null
    },
    setLoading(state, action: SetLoading) {
      state.loadingState = action.payload
    },
    markAsReviewedSuccess(state, action: MarkAsReviewedSuccess) {
      state.loadingState = LoadingState.LOADED
      state.error = null
    },
    markAsReviewedFailure(state, action: MarkAsReviewedFailure) {
      state.loadingState = LoadingState.ERROR
      state.error = action.payload
    },
    setBundleDrawerOpen(state, action: SetBundleDrawerOpen) {
      state.isBundleDrawerOpen = action.payload
    },
  },
})

export const {
  getNotifications,
  getNotificationsSuccess,
  getNotificationsFailure,
  markAsReviewed,
  markAsReviewedSuccess,
  markAsReviewedFailure,
  updateNotifications,
  updateNotificationsSuccess,
  updateNotificationsFailure,
  setLoading,
  setBundleDrawerOpen,
} = notificationsSlice.actions

export const notificationsReducer = notificationsSlice.reducer
